import { Component, OnInit } from '@angular/core';
import { BasketService } from '../../marketplace/services/basket.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-basket-indicator',
  templateUrl: './basket-indicator.component.html',
  styleUrls: ['./basket-indicator.component.css'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    CommonModule,
    RouterLink,
  ]
})
export class BasketIndicatorComponent implements OnInit {

  totalItems$ = this.basketService.totalItems$
  cartIcon = faCartShopping

  constructor(private readonly basketService: BasketService) {
    console.log('BasketIndicatorComponent:: construction')
    this.totalItems$.subscribe(items => {
      console.log('BasketIndicatorComponent:: totalItems$', items)
    })
  }

  ngOnInit(): void {
    console.log('BasketIndicatorComponent:: ngOnInit')
  }

}
